export class CountryCheck {
    State: string;
    Zip: string = null;
    City: string = null;
    Email: string;
    Jurisdiction: string;
    OrderId: any;
}